import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Mail, ArrowRight } from "lucide-react";

export default function NewsletterSignup({ variant = "inline" }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) { toast.error("Enter a valid email."); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, name });
      if (data.already) toast.info("You're already on the list.");
      else toast.success("Subscribed. See you Sunday.");
      setDone(true);
    } catch {
      toast.error("Could not subscribe. Try again.");
    } finally { setBusy(false); }
  };

  const dark = variant === "dark";
  const bg = dark ? "bg-[#0A0A0A] text-[#F4F4F0]" : "bg-white text-[#0A0A0A]";
  const inputBg = dark ? "bg-[#141414] text-[#F4F4F0] border-[#333]" : "bg-[#F4F4F0] border-[#0A0A0A]";

  if (done && variant !== "inline") return (
    <div className={`${bg} border-ink p-6 shadow-brut-sm`} data-testid="newsletter-thanks">
      <div className="tag-red mb-2 inline-block">Subscribed</div>
      <h3 className="font-display text-2xl">See you Sunday.</h3>
      <p className="font-body text-sm mt-2 opacity-80">
        The Weekly Candour Report drops every Sunday — ten honest sentences, straight to your inbox.
      </p>
    </div>
  );

  return (
    <section className={`${bg} border-ink shadow-brut ${variant === "inline" ? "p-8 md:p-10" : "p-6"}`} data-testid={`newsletter-${variant}`}>
      <div className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <div className="tag-red inline-block mb-3">Weekly Candour Report</div>
          <h2 className={`font-display ${variant === "inline" ? "text-4xl md:text-5xl" : "text-2xl"} leading-tight`}>
            Ten honest sentences.<br/>
            <em className="font-quote">Every Sunday.</em>
          </h2>
          <p className="font-body text-sm md:text-base mt-3 opacity-80 max-w-md">
            The most candid statements from the past week, delivered before you finish your coffee.
          </p>
        </div>
        <form onSubmit={submit} className="space-y-3" data-testid="newsletter-form">
          <input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="First name (optional)"
            className={`border-ink px-4 py-3 font-body w-full ${inputBg}`}
            data-testid="newsletter-name"
          />
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@somewhere.com"
            className={`border-ink px-4 py-3 font-body w-full ${inputBg}`}
            data-testid="newsletter-email"
          />
          <button type="submit" disabled={busy} className="btn-ink w-full flex items-center justify-center gap-2" data-testid="newsletter-submit">
            <Mail size={14} /> {busy ? "Filing…" : done ? "Subscribed ✓" : "Subscribe"} {!busy && !done && <ArrowRight size={14} />}
          </button>
        </form>
      </div>
    </section>
  );
}
